export class NoChangeError extends Error {
  constructor() {
    super('No changes made.');
  }
}
